var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstructorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.688,
    height: 41.082,
    viewBox: "0 0 58.688 41.082",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-car-side",
    "data-name": "Icon awesome-car-side",
    d: "M49.885,16.922H48.418L38.443,4.453a5.871,5.871,0,0,0-4.583-2.2H14.244A5.868,5.868,0,0,0,8.8,5.939L4.4,17.129A5.855,5.855,0,0,0,0,22.791v10.27a1.467,1.467,0,0,0,1.467,1.467h4.4a8.8,8.8,0,0,0,17.607,0H35.213a8.8,8.8,0,0,0,17.607,0h4.4a1.467,1.467,0,0,0,1.467-1.467V25.725A8.8,8.8,0,0,0,49.885,16.922ZM14.672,38.93a4.4,4.4,0,1,1,4.4-4.4A4.406,4.406,0,0,1,14.672,38.93Zm6.6-22.008H10.723l3.521-8.8h7.031Zm4.4,0v-8.8H33.86l7.043,8.8ZM44.017,38.93a4.4,4.4,0,1,1,4.4-4.4A4.406,4.406,0,0,1,44.017,38.93Z",
    transform: "translate(0 -2.25)",
    fill: "#afb0ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructorIcon);
export default __webpack_public_path__ + "static/media/InstructorIcon.93f8ea13614e6ed09d9e89118fbfd8c4.svg";
export { ForwardRef as ReactComponent };